import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "products-to-add bg-white border border-1 rounded p-3 pb-0" }
const _hoisted_2 = { class: "normal-filter-conditions" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "fs-5 lh-sm text-white bg-primary rounded m-0 px-2 py-1" }
const _hoisted_5 = { class: "product-filters" }
const _hoisted_6 = {
  key: 0,
  class: "add-buttons d-flex mb-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1)
const _hoisted_11 = {
  key: 1,
  class: "global-excl mb-3"
}
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "fs-5 lh-sm text-white bg-primary rounded m-0 px-2 py-1" }
const _hoisted_14 = {
  key: 0,
  class: "global-forced-include mt-3"
}
const _hoisted_15 = { class: "bg-white border border-1 rounded p-3" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "fs-5 lh-sm text-white bg-primary rounded m-0 px-2 py-1" }
const _hoisted_18 = { class: "body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubmittingOverlay = _resolveComponent("BaseSubmittingOverlay")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_ProductFilterConditionAll = _resolveComponent("ProductFilterConditionAll")!
  const _component_ProductFilterConditionProductList = _resolveComponent("ProductFilterConditionProductList")!
  const _component_ProductFilterConditionBrandsCategories = _resolveComponent("ProductFilterConditionBrandsCategories")!
  const _component_ProductFilterConditionTrademarksCategories = _resolveComponent("ProductFilterConditionTrademarksCategories")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_ProductList = _resolveComponent("ProductList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("header", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('productFilterNormalConditions')), 1)
        ])
      ]),
      _createVNode(_component_BaseSubmittingOverlay, {
        "is-submitting": _ctx.pageUI.isSubmitting() || _ctx.pageUI.isDeleting() || _ctx.pageUI.isAnyItemDeleting()
      }, null, 8, ["is-submitting"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError()
      }, null, 8, ["error"]),
      (!_ctx.pageUI.isReady())
        ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.productFilterConditionAll)
                ? (_openBlock(), _createBlock(_component_ProductFilterConditionAll, {
                    key: 0,
                    modelValue: _ctx.productFilterConditionAll,
                    errors: _ctx.errors,
                    pageUI: _ctx.pageUI,
                    "onUpdate:modelValue": _ctx.updateConditionAll,
                    onFilterRemoved: _cache[0] || (_cache[0] = () => _ctx.removeConditionForType(_ctx.ProductFilterConditionTypeEnum.ALL))
                  }, null, 8, ["modelValue", "errors", "pageUI", "onUpdate:modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.CNK_LIST) || _ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.PRODUCT_CODE_LIST))
                ? (_openBlock(), _createBlock(_component_ProductFilterConditionProductList, {
                    key: 1,
                    productCodes: _ctx.productListConditionProductCodeList,
                    cnkCodes: _ctx.productListConditionCnkCodeList,
                    errors: _ctx.errors,
                    pageUI: _ctx.pageUI,
                    onCnkCodesUpdated: _ctx.updateProductListConditionCnkCodes,
                    onProductCodesUpdated: _ctx.updateProductListConditionProductCodes,
                    onFilterRemoved: _ctx.removeProductListConditions
                  }, null, 8, ["productCodes", "cnkCodes", "errors", "pageUI", "onCnkCodesUpdated", "onProductCodesUpdated", "onFilterRemoved"]))
                : _createCommentVNode("", true),
              (_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.BRANDS_CATEGORIES))
                ? (_openBlock(), _createBlock(_component_ProductFilterConditionBrandsCategories, {
                    key: 2,
                    errors: _ctx.errors,
                    pageUI: _ctx.pageUI,
                    modelValue: _ctx.productFilterConditionBrands,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = (newValue) => _ctx.updateConditionForType(newValue, _ctx.ProductFilterConditionTypeEnum.BRANDS_CATEGORIES)),
                    onFilterRemoved: _cache[2] || (_cache[2] = () => _ctx.removeConditionForType(_ctx.ProductFilterConditionTypeEnum.BRANDS_CATEGORIES))
                  }, null, 8, ["errors", "pageUI", "modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.TRADEMARKS_CATEGORIES))
                ? (_openBlock(), _createBlock(_component_ProductFilterConditionTrademarksCategories, {
                    key: 3,
                    errors: _ctx.errors,
                    pageUI: _ctx.pageUI,
                    modelValue: _ctx.productFilterConditionTrademarks,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = (newValue) => _ctx.updateConditionForType(newValue, _ctx.ProductFilterConditionTypeEnum.TRADEMARKS_CATEGORIES)),
                    onFilterRemoved: _cache[4] || (_cache[4] = () => _ctx.removeConditionForType(_ctx.ProductFilterConditionTypeEnum.TRADEMARKS_CATEGORIES))
                  }, null, 8, ["errors", "pageUI", "modelValue"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.usedFilterConditionTypes.length < 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  ((_ctx.isAllProductsFilterAllowed) && (!_ctx.usedFilterConditionTypes.length))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[5] || (_cache[5] = _withModifiers(() => _ctx.handleAddProductFilter(_ctx.ProductFilterConditionTypeEnum.ALL), ["prevent"])),
                        class: "btn btn-gray d-flex align-items-center me-2"
                      }, [
                        _hoisted_7,
                        _createTextVNode(_toDisplayString(_ctx.$t('addAllProducts')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.CNK_LIST) && !_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.PRODUCT_CODE_LIST) && !_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.ALL))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => _ctx.handleAddProductFilter(_ctx.ProductFilterConditionTypeEnum.CNK_LIST), ["prevent"])),
                        class: "btn btn-gray d-flex align-items-center me-2"
                      }, [
                        _hoisted_8,
                        _createTextVNode(_toDisplayString(_ctx.$t('addProductList')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.BRANDS_CATEGORIES) && !_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.ALL))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => _ctx.handleAddProductFilter(_ctx.ProductFilterConditionTypeEnum.BRANDS_CATEGORIES), ["prevent"])),
                        class: "btn btn-gray d-flex align-items-center me-2"
                      }, [
                        _hoisted_9,
                        _createTextVNode(_toDisplayString(_ctx.$t('addLabsBrandsAndCategories')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.TRADEMARKS_CATEGORIES) && !_ctx.usedFilterConditionTypes.includes(_ctx.ProductFilterConditionTypeEnum.ALL))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        onClick: _cache[8] || (_cache[8] = _withModifiers(() => _ctx.handleAddProductFilter(_ctx.ProductFilterConditionTypeEnum.TRADEMARKS_CATEGORIES), ["prevent"])),
                        class: "btn btn-gray d-flex align-items-center"
                      }, [
                        _hoisted_10,
                        _createTextVNode(_toDisplayString(_ctx.$t('addTrademarksAndCategories')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.localProductFilter.global_exclude_conditions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("header", _hoisted_12, [
                    _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t('productFilterGlobalExcludes')), 1)
                  ]),
                  _createVNode(_component_input_checkbox_boolean, {
                    modelValue: _ctx.localProductFilter.global_exclude_conditions.is_prescription_required_excluded,
                    "onUpdate:modelValue": [
                      _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localProductFilter.global_exclude_conditions.is_prescription_required_excluded) = $event)),
                      _ctx.emitChangedModel
                    ],
                    label: _ctx.$t('is_prescription_required_excluded'),
                    name: _ctx.$t('is_prescription_required_excluded'),
                    errors: _ctx.errors,
                    class: "mb-2"
                  }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
                  _createVNode(_component_input_checkbox_boolean, {
                    modelValue: _ctx.localProductFilter.global_exclude_conditions.is_medicine_prescription_not_required_excluded,
                    "onUpdate:modelValue": [
                      _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localProductFilter.global_exclude_conditions.is_medicine_prescription_not_required_excluded) = $event)),
                      _ctx.emitChangedModel
                    ],
                    label: _ctx.$t('is_medicine_prescription_not_required_excluded'),
                    name: _ctx.$t('is_medicine_prescription_not_required_excluded'),
                    errors: _ctx.errors,
                    class: "mb-2"
                  }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
                  _createVNode(_component_input_checkbox_boolean, {
                    modelValue: _ctx.localProductFilter.global_exclude_conditions.is_veterinary_medicine_excluded,
                    "onUpdate:modelValue": [
                      _cache[11] || (_cache[11] = ($event: any) => ((_ctx.localProductFilter.global_exclude_conditions.is_veterinary_medicine_excluded) = $event)),
                      _ctx.emitChangedModel
                    ],
                    label: _ctx.$t('is_veterinary_medicine_excluded'),
                    name: _ctx.$t('is_veterinary_medicine_excluded'),
                    errors: _ctx.errors,
                    class: "mb-2"
                  }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
                  _createVNode(_component_input_checkbox_boolean, {
                    modelValue: _ctx.localProductFilter.global_exclude_conditions.is_no_customer_specific_price_available_excluded,
                    "onUpdate:modelValue": [
                      _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localProductFilter.global_exclude_conditions.is_no_customer_specific_price_available_excluded) = $event)),
                      _ctx.emitChangedModel
                    ],
                    label: _ctx.$t('is_no_customer_specific_price_available_excluded'),
                    name: _ctx.$t('is_no_customer_specific_price_available_excluded'),
                    errors: _ctx.errors,
                    class: "mb-2"
                  }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
                  _createVNode(_component_input_checkbox_boolean, {
                    modelValue: _ctx.localProductFilter.global_exclude_conditions.is_out_of_pharmacy_stock,
                    "onUpdate:modelValue": [
                      _cache[13] || (_cache[13] = ($event: any) => ((_ctx.localProductFilter.global_exclude_conditions.is_out_of_pharmacy_stock) = $event)),
                      _ctx.emitChangedModel
                    ],
                    label: _ctx.$t('is_out_of_pharmacy_stock'),
                    name: _ctx.$t('is_out_of_pharmacy_stock'),
                    errors: _ctx.errors,
                    class: "mb-2"
                  }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    (_ctx.localProductFilter.global_exclude_conditions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("section", _hoisted_15, [
            _createElementVNode("header", _hoisted_16, [
              _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.$t('productFilterGlobalIncludeCnkList')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_ProductList, {
                "model-value": _ctx.globalIncludedProducts,
                "onUpdate:modelValue": _ctx.updateGlobalIncludedProducts,
                height: 150,
                name: "global_forced_included_products",
                errors: _ctx.errors
              }, null, 8, ["model-value", "onUpdate:modelValue", "errors"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}